<template>
  <div class="animated revealUp" style="zoom: 0.9">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("paymentmode") }}
      </div>
      <router-link class="btn-blue" to="payment-modes"
        >{{ $tc("paymentmode") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in PaymentModes"
          :key="index"
          v-if="showField(item)"
          :class="item.hasOwnProperty('class') ? item.class : ''"
          class="align-self-center mb-4"
        >
          <div v-if="item.fieldname !== 'pm_is_active'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <Tooltip :title="$t(item.tooltip)" />
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has(item.fieldname)">{{
                errors.first(`${item.fieldname}`)
              }}</span>
            </p>
          </div>
          <div v-if="item.fieldname === 'pm_is_active'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
              <label class="ios-switch">
                <input
                  type="checkbox"
                  class="ios-checkbox"
                  v-model="item.fieldvalue"
                />
                <span class="switch-slider"></span>
              </label>
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <b-form-checkbox
              v-for="(source, sourceIndex) in bookingSources"
              :key="sourceIndex"
              v-model="selectedSources"
              :value="source"
              class="j-checkbox"
            >
              <div class="mr-2">{{ source.bs_source }}</div>
            </b-form-checkbox>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button class="btn-blue" @click.prevent.stop="handleSubmit(true)">
            {{ $t("save") }}
          </button>
          <button
            @click.prevent.stop="handleSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetHandler()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="payment-modes"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PaymentModes from "@/helper/formJSONMaster/PaymentModes";

export default {
  data() {
    return {
      PaymentModes: PaymentModes.ms_payment_modes,
      // v-validate="'required|email'"
      submitted: false,
      Methods: PaymentModes.Methods,
      bookingSources: [],
      sourceOptions: [],
      selectedSources: [],
    };
  },
  mounted() {
    console.log("PaymentModes :", PaymentModes);
    this.resetHandler();
    this.getBookingSources();
  },
  computed: {
    showErpColumns() {
      return this.$store.getters.SHOW_ERP_GL_FIELDS == "Y" ? true : false;
    },
  },
  methods: {
    showField(item) {
      let status = true; //show

      if(item.fieldname == 'pm_id' ) {
        status = false
      } else if (!this.showErpColumns && item.fieldkey == 'erp_field') {
         status = false
      } else {
        status = true
      }
      return status;
    },
    getBookingSources() {
      let body = {
        tableName: "ms_booking_sources",
        bs_is_active: "Y",
      };
      MasterService.GetActiveList(body).then((response) => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records.length > 0) {
            this.bookingSources = data.Records;
            console.log("this.bookingSources :>> ", this.bookingSources);
          }
        } else this.$toasted.show(data.message || "Opps! Something went wrong");
      });
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    resetHandler: function () {
      this.PaymentModes.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    handleSubmit(flag) {
      console.log("call submit :");
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid) {
          console.log("valid :", valid);
          let body = this.getRequestBody(
            "POST",
            this.PaymentModes,
            this.Methods
          );
          console.log("body :", body);

          MasterService.GlobalRequest(body)
            .then((response) => {
              const { data } = response;
              if (data.status) {
                let payload = {
                  selected_sources: this.selectedSources,
                  payment_mode_id: data.insertId,
                };
                MasterService.AddBsPaymentMapping(payload).then((response) => {
                  const { data } = response;
                  if (data.status) {
                    if (flag) {
                      this.$router.push({
                        path: "/master/payment-modes",
                      });
                    } else {
                      this.resetHandler();
                    }
                  } else {
                    this.$toasted.show(data.message);
                  }
                });
              } else {
                this.$toasted.show(data.message);
                console.log("show error1 :", data.message);
              }
            })
            .catch((error) => {
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/PaymentModesComponents/addPaymentMode.vue